import store from '../store'
import { OauthService } from '../services';
import { AuthUser } from '../models';
import lodash from 'lodash';
import router from '../routes'
import firebase from 'firebase/compat/app'
import  SocketsService  from '../services/SocketsService';
let _jwt = '';
let _new_jwt = '';
let _is_master_token = false;

export const getDecodedJWT = (token: string) => {
  return JSON.parse(atob(token.split('.')?.[1]?.replace(/-/g, '+')?.replace(/_/g, '/')))
}

export const isJwtTokenExpired = (token: string | undefined) => {
    try {
        if(!token) {
            throw new Error('Empty token')
        }
        const decodedPayload = JSON.parse(atob(token.split('.')?.[1]?.replace(/-/g, '+')?.replace(/_/g, '/')))
        return Date.now() >= (decodedPayload?.exp * 1000)
    } catch (error) {
        console.warn('Error while checking token', token, error)
        return true
    }
}

export const getJWT = async (isNew : boolean = false) => {
    try{
        if (_jwt && isJwtTokenExpired(_jwt)) {
            const authUser: AuthUser = lodash.cloneDeep(await store.dispatch('auth/get'))

            const refreshToken = (_is_master_token) ? authUser.masterUser?.refreshJwt : authUser?.refreshJwt
            const newRefreshToken = (_is_master_token) ? authUser.masterUser?.refreshToken : authUser?.refreshToken
            if(isJwtTokenExpired(refreshToken)) {
                console.info('Token Expired. Please login again!')
                logout()
                return ''
            }
            if(refreshToken) {
                const response = await OauthService.refreshToken(refreshToken)
                // Trigger refresh for new token as well
                let v2Response = null
                try {
                    v2Response = await OauthService.refreshJwt(newRefreshToken)
                } catch (error) {
                    // FIXME: Hotfix for new token. Will be removed soon
                }
                if (_is_master_token && authUser?.masterUser) {
                    authUser.masterUser.jwt = response.jwt
                    if(v2Response) {
                        authUser.masterUser.authToken = v2Response.jwt
                        authUser.masterUser.refreshToken = v2Response.refreshJwt
                    }
                } else {
                    authUser.jwt = response.jwt
                    if (v2Response) {
                        authUser.authToken = v2Response.jwt
                        authUser.refreshToken = v2Response.refreshJwt
                    }
                }

                await store.dispatch('auth/set', authUser)

                if (_is_master_token && authUser?.masterUser) {
                    setJWT(authUser.masterUser.jwt, authUser.masterUser.authToken, true)
                }
            }
        }
        if(isNew) {
            return _new_jwt
        }
        return _jwt;
    } catch( error){
        console.info('Error while refreshing token. Please login again!',error)
        logout()
    }
};

const logout = async () => {
    try {
        localStorage.removeItem('recentlyVisitedUsers')
        await router.push({ name: 'login', params: { logout: 'true' } })
        await store.dispatch('logout')
        await firebase.auth().signOut()
    } catch (err) {
        await router.push({ name: 'login', params: { logout: 'true' } })
    }
}

export const setJWT = (token: string, new_jwt: string, is_master_token: boolean = false) => {
    _jwt = token
    _new_jwt = new_jwt
    _is_master_token = is_master_token
    try{
        SocketsService.init(new_jwt)
    }catch(error){
        console.error('Socket Error', error)
    }
};

